var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.136,
    x2: 254.287,
    xlinkHref: "#lg1",
    y1: 133.679,
    y2: 316.903
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.742,
    x2: 158.658,
    xlinkHref: "#lg1",
    y1: 250.191,
    y2: 102.472
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65e0db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#27d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.801,
    x2: 125.801,
    xlinkHref: "#lg2",
    y1: 243.612,
    y2: 335.483
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.867,
    x2: 388.867,
    xlinkHref: "#lg2",
    y1: 243.612,
    y2: 335.483
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.726,
    x2: 360.159,
    xlinkHref: "#lg3",
    y1: 228.671,
    y2: 162.596
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.972,
    x2: 484.802,
    xlinkHref: "#lg4",
    y1: 291.861,
    y2: 309.836
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.194,
    x2: 45.194,
    xlinkHref: "#lg5",
    y1: 322.105,
    y2: 356.272
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.806,
    x2: 464.806,
    xlinkHref: "#lg5",
    y1: 322.105,
    y2: 356.272
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.562,
    x2: 177.664,
    xlinkHref: "#lg5",
    y1: 331.004,
    y2: 399.105
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#b6b7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6581,
    stopColor: "#a097a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b788a"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.553,
    x2: 95.958,
    xlinkHref: "#lg6",
    y1: 367.995,
    y2: 317.4
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b788a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.157,
    x2: 122.755,
    xlinkHref: "#lg7",
    y1: 377.603,
    y2: 344.201
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.326,
    x2: 144.201,
    xlinkHref: "#lg5",
    y1: 339.769,
    y2: 365.643
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471,
    stopColor: "#6e566e",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.495,
    x2: 153.953,
    xlinkHref: "#lg8",
    y1: 354.9,
    y2: 303.831
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.629,
    x2: 440.73,
    xlinkHref: "#lg5",
    y1: 331.004,
    y2: 399.105
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.619,
    x2: 359.024,
    xlinkHref: "#lg6",
    y1: 367.995,
    y2: 317.4
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.223,
    x2: 385.821,
    xlinkHref: "#lg7",
    y1: 377.603,
    y2: 344.201
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.393,
    x2: 407.267,
    xlinkHref: "#lg5",
    y1: 339.769,
    y2: 365.643
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.561,
    x2: 417.02,
    xlinkHref: "#lg8",
    y1: 354.9,
    y2: 303.831
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.054,
    x2: 257.054,
    xlinkHref: "#lg5",
    y1: 322.105,
    y2: 356.272
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.373,
    x2: 109.706,
    xlinkHref: "#lg3",
    y1: 210.647,
    y2: 83.981
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.515,
    x2: 170.972,
    xlinkHref: "#lg4",
    y1: 151.243,
    y2: 197.515
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.708,
    x2: 282.303,
    xlinkHref: "#lg4",
    y1: 141.091,
    y2: 209.427
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.485,
    x2: 30.865,
    y1: 271.768,
    y2: 295.905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.579,
    x2: 355.598,
    xlinkHref: "#lg3",
    y1: 224.346,
    y2: 281.352
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.458,
    x2: 376.088,
    xlinkHref: "#lg5",
    y1: 189.831,
    y2: 206.376
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 259,
    x2: 259,
    xlinkHref: "#lg1",
    y1: 247.325,
    y2: 224.303
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 88,
    x2: 88,
    xlinkHref: "#lg1",
    y1: 231.847,
    y2: 222.086
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 88,
    x2: 88,
    xlinkHref: "#lg1",
    y1: 243.847,
    y2: 234.086
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 88,
    x2: 88,
    xlinkHref: "#lg1",
    y1: 255.847,
    y2: 246.086
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.306 211.165h-23.741c-10.659 0-19.845-7.503-21.974-17.947l-25.354-40.742c-18.805-30.217-51.874-48.588-87.465-48.588h-121.388c-29.548 0-54.426 22.101-57.908 51.443l-8.699 35.69c-1.363 11.489-11.104 20.143-22.674 20.143-20.542 0-37.81 15.426-40.116 35.838l-9.753 78.858c-1.163 10.291 6.888 19.303 17.245 19.303h461.037c11.151 0 19.408-10.365 16.915-21.234l-16.713-65.437c-6.351-27.693-30.997-47.327-59.412-47.327z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.002 182.558c-6.468-31.729-34.375-54.521-66.756-54.521h-133.45c-13.402 0-24.685 10.024-26.264 23.332 0 0-5.505 31.828-8.664 49.056-1.026 5.594 3.272 10.74 8.959 10.74h220.958c5.781 0 10.1-5.317 8.913-10.976z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m210.217 345.165h-168.831c1.099-48.997 38.466-88.334 84.421-88.334 45.943 0 83.311 39.337 84.41 88.334z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.288 345.165h-168.841c1.099-48.997 38.477-88.334 84.421-88.334 45.943 0 83.321 39.337 84.42 88.334z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m492.578 343.67-131.772-124.329c-1.89-.616-3.266-2.383-3.266-4.478v-34.892c0-2.609 2.116-4.735 4.735-4.735 6.317 0 12.028 2.64 16.054 6.892l2.26 11.093c2.136 10.446 11.319 17.944 21.981 17.944h23.737c28.411 0 53.062 19.639 59.41 47.331l9.234 32.8 7.478 32.632c1.93 8.392-2.569 16.496-9.851 19.742z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.887 271.096v74.069h20.71c11.151 0 19.408-10.365 16.915-21.234l-13.101-57.131c-.536-2.339-2.618-3.997-5.017-3.997h-11.214c-4.58 0-8.293 3.713-8.293 8.293z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.608 351.137h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.22 351.137h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.677 347.249c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.801,
    cy: 347.244,
    fill: "url(#SVGID_10_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.062 372.363c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.801,
    cy: 347.244,
    fill: "url(#SVGID_12_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.739 329.375c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.744 347.249c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.868,
    cy: 347.244,
    fill: "url(#SVGID_15_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.128 372.363c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.868,
    cy: 347.244,
    fill: "url(#SVGID_17_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.805 329.375c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_18_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m311.366 351.137h-108.623c-5.808 0-10.516-4.708-10.516-10.516v-20.739c0-5.808 4.708-10.516 10.516-10.516h108.623c5.808 0 10.516 4.708 10.516 10.516v20.739c0 5.808-4.708 10.516-10.516 10.516z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.718 258.495c-6.351-27.696-30.997-47.33-59.412-47.33h-23.741c-10.659 0-19.845-7.503-21.974-17.947l-25.354-40.742c-18.805-30.217-51.874-48.588-87.465-48.588h-66.772v241.276h284.516c11.151 0 19.408-10.365 16.915-21.234z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.891 145.683c0-3.839-3.112-6.951-6.951-6.951h-30.313c-11.89 0-21.9 8.248-23.301 19.198 0 0-5.704 12.752-8.32 33.643-.592 4.726 3.094 8.894 7.857 8.894h54.077c3.839 0 6.951-3.112 6.951-6.951z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.338 191.131c-2.688-15.58-21.634-52.398-63.319-52.398h-51.019c-3.611 0-6.539 3.112-6.539 6.951v47.835c0 3.839 2.928 6.951 6.539 6.951h107.01c4.652-.001 8.167-4.476 7.328-9.339z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.18 299.437h21.589c2.496 0 4.519-2.023 4.519-4.519v-24.516c0-2.496-2.023-4.519-4.519-4.519h-18.818c-2.299 0-4.232 1.727-4.49 4.011l-2.771 24.517c-.303 2.68 1.794 5.026 4.49 5.026z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.104 252.785c-8.229-24.643-31.379-41.619-57.798-41.619h-23.74c-10.659 0-19.845-7.503-21.974-17.947v36.367c0 12.813 10.387 23.199 23.199 23.199z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.274 219.6c-2.617 0-4.739-2.122-4.739-4.739v-34.886c0-2.617 2.122-4.739 4.739-4.739 12.251 0 22.182 9.931 22.182 22.182 0 12.251-9.931 22.182-22.182 22.182z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.026 242.825h-28.051c-4.542 0-8.224-3.682-8.224-8.224v-2.537c0-4.542 3.682-8.224 8.224-8.224h28.051c4.542 0 8.224 3.682 8.224 8.224v2.537c0 4.542-3.682 8.224-8.224 8.224z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m99.975 229.939h-23.95c-2.223 0-4.025-1.802-4.025-4.025 0-2.223 1.802-4.025 4.025-4.025h23.95c2.223 0 4.025 1.802 4.025 4.025 0 2.223-1.802 4.025-4.025 4.025z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.975 241.939h-23.95c-2.223 0-4.025-1.802-4.025-4.025 0-2.223 1.802-4.025 4.025-4.025h23.95c2.223 0 4.025 1.802 4.025 4.025 0 2.223-1.802 4.025-4.025 4.025z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.975 253.939h-23.95c-2.223 0-4.025-1.802-4.025-4.025 0-2.223 1.802-4.025 4.025-4.025h23.95c2.223 0 4.025 1.802 4.025 4.025 0 2.223-1.802 4.025-4.025 4.025z",
    fill: "url(#SVGID_29_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.93b47cbe15e8354db1082a1bedf829b2.svg";
export { ForwardRef as ReactComponent };